import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, View, TouchableOpacity, RefreshControl } from 'react-native';
import trackerApi from '../../api/tracker';
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';

const width = Dimensions.get('window').width;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
export const NewsScreen = () => {
  const [data, setData] = React.useState([]);
  const [refreshing, setRefreshing] = useState(true);
  React.useEffect(()=>{
    getData();
  },[])
  const onRefresh = () => {
    //Clear old data of the list
    console.log('refreshing');
    //Call the Service to get the latest data

  };
  const getData = async ()=>{
    const q = {
          q: '',
          page: 1,
          status: '',
          sort: 'desc',
          perPage: 10,
          sortColumn: 'id'
        }
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/get/news', {q},{
      headers: {Authorization: `Bearer ${token}`}
    });
    setData(response.data.allData);
  }

  return (
      <Layout style={styles.container} level='3' >
      <SafeAreaView>
      <ScrollView>
        <Text category='h5' status='primary' style={{marginTop:20, textAlign:'center'}}>اخبار و اطلاعیه ها</Text>
        { data.length==0&&
          <Text category='c1' appearance='hint' style={{marginTop:50, textAlign:'center'}}>موردی برای نمایش وجود ندارد.</Text>

        }
        <Layout style={{borderRadius:10, marginTop:20}}>


        {
          data.map((data)=>{
            if(data.priority=='pin') return(
              <View>
              <TouchableOpacity onPress={()=>{RootNavigation.navigate('SingleNews',{news:data})}}>
              <View style={{flexDirection:'row', width, paddingVertical:3, justifyContent:'space-between'}}>
                <View style={{flexDirection:'row'}}>
                <View style={{backgroundColor: data.receiver != 'all' ? '#fe52fa' : '#8f00f5', width:5, borderTopRightRadius:10, borderBottomRightRadius:10}}/>
                <View style={{marginVertical:10 , marginHorizontal:20}}>
                  <Text category='h6'>{data.title}</Text>
                  <Text category='c1'>{data.subtitle}</Text>
                </View>
                </View>
                <View style={{margin:10}}>
                  <Text appearance='hint' category='c1'>{data.create_date.split('T')[0]}</Text>
		  <Text appearance='hint' category='c1'>{data.create_date.split('T')[1].split('.')[0]}</Text>
                </View>
              </View>
              </TouchableOpacity>
              <Divider />
              </View>
            )
          })
        }

        {
          data.map((data)=>{
            if(data.priority!='pin') return(
              <View>
              <TouchableOpacity onPress={()=>{RootNavigation.navigate('SingleNews',{news:data})}}>
              <View style={{flexDirection:'row', width, paddingVertical:3, justifyContent:'space-between'}}>
                <View style={{flexDirection:'row'}}>
                <View style={{backgroundColor:data.receiver != 'all' ? '#fe85fa' : '#8f00f5', width:5, borderTopRightRadius:10, borderBottomRightRadius:10}}/>
                <View style={{marginVertical:10 , marginHorizontal:20}}>
                  <Text category='h6'>{data.title}</Text>
                  <Text category='c1'>{data.subtitle}</Text>
                </View>
                </View>
                <View style={{margin:10}}>
                  <Text appearance='hint' category='c1'>{data.create_date.split('T')[0]}</Text>
        <Text appearance='hint' category='c1'>{data.create_date.split('T')[1].split('.')[0]}</Text>
                </View>
              </View>
              </TouchableOpacity>
              <Divider />
              </View>
            )
          })
        }




        </Layout>
        </ScrollView>
        <Button onPress={()=>{RootNavigation.navigate('Menu')}} appearance='outline' style={{borderRadius:10, marginBottom:5, marginTop:10, marginHorizontal:30}}>بازگشت</Button>

      </SafeAreaView>

      </Layout>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    paddingBottom:25,
    width

  },
});
